import { removeNulls } from 'utils';
import { lastGPS2Position } from 'console/entities/device.map.markers/lib';
export function generateClusterPoints(stat_devices, moved_devices, device_errors) {
    let points = [];
    points = Object.entries(stat_devices)
        .filter(([, dev_loc]) => dev_loc.location != null)
        .map(([device_id, dev_loc]) => {
        const _device_id = parseInt(device_id, 10);
        return {
            type: 'Feature',
            properties: {
                cluster: false,
                is_moved: false,
                device_id: _device_id,
                errors: device_errors[_device_id],
                ...dev_loc,
            },
            geometry: {
                type: 'Point',
                coordinates: dev_loc.location,
            },
        };
    });
    points = points.concat(Object.entries(moved_devices)
        .filter(([, dev_loc]) => dev_loc.locations != null)
        .map(([device_id, dev_loc]) => {
        const _device_id = parseInt(device_id, 10);
        const [prev_position, position] = lastGPS2Position(removeNulls(dev_loc.locations ?? []));
        return {
            type: 'Feature',
            properties: {
                cluster: false,
                is_moved: true,
                device_id: _device_id,
                prev_position,
                position,
                ...dev_loc,
            },
            geometry: {
                type: 'Point',
                coordinates: position,
            },
        };
    }));
    return points;
}
